<!--start back-to-top-->
<button class="btn btn-danger btn-icon" id="back-to-top" (click)="topFunction()">
    <i class="ri-arrow-up-line"></i>
</button>
<!--end back-to-top-->

<!--preloader-->
<!-- <div id="preloader">
    <div id="status">
        <div class="spinner-border text-primary avatar-sm" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
    </div>
</div> -->

<div class="customizer-setting d-none d-md-block print-icon">
  <div class="d-flex gap-2">
    <div class="btn-primary btn-rounded shadow-lg btn btn-icon btn-lg p-2" (click)="openEnd()">
        <i class='mdi mdi-spin mdi-cog-outline fs-22'></i>
    </div>
    <div class="btn-primary btn-rounded shadow-lg btn btn-icon btn-lg p-2" (click)="openAiChat()">
        <i class='las la-comment-dots fs-22'></i>
    </div>
  </div>
</div>

<!-- Theme Settings -->
<div class="offcanvas offcanvas-end border-0" tabindex="-1" id="theme-settings-offcanvas">
  <div class="d-flex align-items-center bg-primary bg-gradient p-3 offcanvas-header">
    <h5 class="m-0 me-2 text-white">{{ 'THEME_SETTINGS.THEME_CUSTOMIZER' | translate }}</h5>

    <button type="button" class="btn-close btn-close-white ms-auto" id="customizerclose-btn"
            (click)="closeoffcanvas()" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
    <div class="offcanvas-body p-0">
        <ngx-simplebar class="h-100">
            <div>
                <div class="p-4">
                  <h6 class="mb-0 fw-semibold text-uppercase">{{ 'THEME_SETTINGS.LAYOUT' | translate }}</h6>
                  <p class="text-muted">{{ 'THEME_SETTINGS.CHOOSE_YOUR_LAYOUT' | translate }}</p>

                    <div class="row">
                        <div class="col-4">
                            <div class="form-check card-radio">
                                <input id="customizer-layout01" name="data-layout" type="radio" value="vertical"
                                    class="form-check-input" (click)="changeLayout('vertical')" [checked]="layout == 'vertical'">
                                <label class="form-check-label p-0 avatar-md w-100" for="customizer-layout01">
                                    <span class="d-flex gap-1 h-100">
                                        <span class="flex-shrink-0">
                                            <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                                                <span
                                                    class="d-block p-1 px-2 bg-primary-subtle text-primary  rounded mb-2"></span>
                                                <span
                                                    class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                <span
                                                    class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                <span
                                                    class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                            </span>
                                        </span>
                                        <span class="flex-grow-1">
                                            <span class="d-flex h-100 flex-column">
                                                <span class="bg-light d-block p-1"></span>
                                                <span class="bg-light d-block p-1 mt-auto"></span>
                                            </span>
                                        </span>
                                    </span>
                                </label>
                            </div>
                          <h5 class="fs-13 text-center mt-2">{{ 'THEME_SETTINGS.VERTICAL' | translate }}</h5>
                        </div>
                        <div class="col-4">
                            <div class="form-check card-radio">
                                <input id="customizer-layout02" name="data-layout" type="radio" value="horizontal"
                                    class="form-check-input" (click)="changeLayout('horizontal')" [checked]="layout == 'horizontal'">
                                <label class="form-check-label p-0 avatar-md w-100" for="customizer-layout02">
                                    <span class="d-flex h-100 flex-column gap-1">
                                        <span class="bg-light d-flex p-1 gap-1 align-items-center">
                                            <span
                                                class="d-block p-1 bg-primary-subtle text-primary  rounded me-1"></span>
                                            <span
                                                class="d-block p-1 pb-0 px-2 bg-primary-subtle text-primary  ms-auto"></span>
                                            <span class="d-block p-1 pb-0 px-2 bg-primary-subtle text-primary "></span>
                                        </span>
                                        <span class="bg-light d-block p-1"></span>
                                        <span class="bg-light d-block p-1 mt-auto"></span>
                                    </span>
                                </label>
                            </div>
                          <h5 class="fs-13 text-center mt-2">{{ 'THEME_SETTINGS.HORIZONTAL' | translate }}</h5>
                        </div>
                        <!-- end col -->
                    </div>

                  <h6 class="mt-4 mb-0 fw-semibold text-uppercase">{{ 'THEME_SETTINGS.COLOR_SCHEME' | translate }}</h6>
                  <p class="text-muted">{{ 'THEME_SETTINGS.CHOOSE_LIGHT_OR_DARK_SCHEME' | translate }}</p>

                    <div class="colorscheme-cardradio">
                        <div class="row">
                            <div class="col-4">
                                <div class="form-check card-radio">
                                    <input class="form-check-input" type="radio" name="data-bs-theme"
                                        id="layout-mode-light" value="light" [checked]="mode === 'light'"
                                        (change)="changeMode('light')">
                                    <label class="form-check-label p-0 avatar-md w-100" for="layout-mode-light">
                                        <span class="d-flex gap-1 h-100">
                                            <span class="flex-shrink-0">
                                                <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                                                    <span
                                                        class="d-block p-1 px-2 bg-primary-subtle text-primary  rounded mb-2"></span>
                                                    <span
                                                        class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                    <span
                                                        class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                    <span
                                                        class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                </span>
                                            </span>
                                            <span class="flex-grow-1">
                                                <span class="d-flex h-100 flex-column">
                                                    <span class="bg-light d-block p-1"></span>
                                                    <span class="bg-light d-block p-1 mt-auto"></span>
                                                </span>
                                            </span>
                                        </span>
                                    </label>
                                </div>
                              <h5 class="fs-13 text-center mt-2">{{ 'THEME_SETTINGS.LIGHT' | translate }}</h5>
                            </div>

                            <div class="col-4">
                                <div class="form-check card-radio dark">
                                    <input class="form-check-input" type="radio" name="data-bs-theme"
                                        id="layout-mode-dark" value="dark" [checked]="mode === 'dark'"
                                        (change)="changeMode('dark')">
                                    <label class="form-check-label p-0 avatar-md w-100 bg-dark" for="layout-mode-dark">
                                        <span class="d-flex gap-1 h-100">
                                            <span class="flex-shrink-0">
                                                <span
                                                    class="bg-light-subtle text-light  d-flex h-100 flex-column gap-1 p-1">
                                                    <span
                                                        class="d-block p-1 px-2 bg-light-subtle text-light  rounded mb-2"></span>
                                                    <span
                                                        class="d-block p-1 px-2 pb-0 bg-light-subtle text-light "></span>
                                                    <span
                                                        class="d-block p-1 px-2 pb-0 bg-light-subtle text-light "></span>
                                                    <span
                                                        class="d-block p-1 px-2 pb-0 bg-light-subtle text-light "></span>
                                                </span>
                                            </span>
                                            <span class="flex-grow-1">
                                                <span class="d-flex h-100 flex-column">
                                                    <span class="bg-light-subtle text-light  d-block p-1"></span>
                                                    <span
                                                        class="bg-light-subtle text-light  d-block p-1 mt-auto"></span>
                                                </span>
                                            </span>
                                        </span>
                                    </label>
                                </div>
                              <h5 class="fs-13 text-center mt-2">{{ 'THEME_SETTINGS.DARK' | translate }}</h5>
                            </div>
                        </div>
                    </div>
                    @if(layout === 'vertical' || layout === 'horizontal'){
                    <div id="layout-width">
                      <h6 class="mt-4 mb-0 fw-semibold text-uppercase">{{ 'THEME_SETTINGS.LAYOUT_WIDTH' | translate }}</h6>
                      <p class="text-muted">{{ 'THEME_SETTINGS.CHOOSE_FLUID_OR_BOXED_LAYOUT' | translate }}</p>

                        <div class="row">
                            <div class="col-4">
                                <div class="form-check card-radio">
                                    <input class="form-check-input" type="radio" name="data-layout-width"
                                        id="layout-width-fluid" value="fluid" [checked]="width === 'fluid'"
                                        (change)="changeWidth('fluid')">
                                    <label class="form-check-label p-0 avatar-md w-100" for="layout-width-fluid">
                                        <span class="d-flex gap-1 h-100">
                                            <span class="flex-shrink-0">
                                                <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                                                    <span
                                                        class="d-block p-1 px-2 bg-primary-subtle text-primary  rounded mb-2"></span>
                                                    <span
                                                        class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                    <span
                                                        class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                    <span
                                                        class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                </span>
                                            </span>
                                            <span class="flex-grow-1">
                                                <span class="d-flex h-100 flex-column">
                                                    <span class="bg-light d-block p-1"></span>
                                                    <span class="bg-light d-block p-1 mt-auto"></span>
                                                </span>
                                            </span>
                                        </span>
                                    </label>
                                </div>
                              <h5 class="fs-13 text-center mt-2">{{ 'THEME_SETTINGS.FLUID' | translate }}</h5>
                            </div>
                            <div class="col-4">
                                <div class="form-check card-radio">
                                    <input class="form-check-input" type="radio" name="data-layout-width"
                                        id="layout-width-boxed" value="boxed" [checked]="width === 'boxed'"
                                        (change)="changeWidth('boxed')">
                                    <label class="form-check-label p-0 avatar-md w-100 px-2" for="layout-width-boxed">
                                        <span class="d-flex gap-1 h-100 border-start border-end">
                                            <span class="flex-shrink-0">
                                                <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                                                    <span
                                                        class="d-block p-1 px-2 bg-primary-subtle text-primary  rounded mb-2"></span>
                                                    <span
                                                        class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                    <span
                                                        class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                    <span
                                                        class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                </span>
                                            </span>
                                            <span class="flex-grow-1">
                                                <span class="d-flex h-100 flex-column">
                                                    <span class="bg-light d-block p-1"></span>
                                                    <span class="bg-light d-block p-1 mt-auto"></span>
                                                </span>
                                            </span>
                                        </span>
                                    </label>
                                </div>
                              <h5 class="fs-13 text-center mt-2">{{ 'THEME_SETTINGS.BOXED' | translate }}</h5>
                            </div>
                        </div>
                    </div>
                    }

                  <div id="layout-position">
                    <h6 class="mt-4 mb-0 fw-semibold text-uppercase">{{ 'THEME_SETTINGS.LAYOUT_POSITION' | translate }}</h6>
                    <p class="text-muted">{{ 'THEME_SETTINGS.CHOOSE_FIXED_OR_SCROLLABLE_LAYOUT_POSITION' | translate }}</p>

                    <div class="btn-group radio" role="group">
                      <input type="radio" class="btn-check" name="data-layout-position" id="layout-position-fixed"
                             value="fixed" [checked]="position === 'fixed'" (change)="changePosition('fixed')">
                      <label class="btn btn-light w-sm" for="layout-position-fixed">{{ 'THEME_SETTINGS.FIXED' | translate }}</label>

                      <input type="radio" class="btn-check" name="data-layout-position"
                             id="layout-position-scrollable" value="scrollable" [checked]="position === 'scrollable'"
                             (change)="changePosition('scrollable')">
                      <label class="btn btn-light w-sm ms-0" for="layout-position-scrollable">{{ 'THEME_SETTINGS.SCROLLABLE' | translate }}</label>
                    </div>
                  </div>

                  <h6 class="mt-4 mb-0 fw-semibold text-uppercase">{{ 'THEME_SETTINGS.TOPBAR_COLOR' | translate }}</h6>
                  <p class="text-muted">{{ 'THEME_SETTINGS.CHOOSE_LIGHT_OR_DARK_TOPBAR_COLOR' | translate }}</p>


                    <div class="row">
                        <div class="col-4">
                            <div class="form-check card-radio">
                                <input class="form-check-input" type="radio" name="data-topbar" id="topbar-color-light"
                                    value="light" [checked]="topbar === 'light'" (change)="changeTopColor('light')">
                                <label class="form-check-label p-0 avatar-md w-100" for="topbar-color-light">
                                    <span class="d-flex gap-1 h-100">
                                        <span class="flex-shrink-0">
                                            <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                                                <span
                                                    class="d-block p-1 px-2 bg-primary-subtle text-primary  rounded mb-2"></span>
                                                <span
                                                    class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                <span
                                                    class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                <span
                                                    class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                            </span>
                                        </span>
                                        <span class="flex-grow-1">
                                            <span class="d-flex h-100 flex-column">
                                                <span class="bg-light d-block p-1"></span>
                                                <span class="bg-light d-block p-1 mt-auto"></span>
                                            </span>
                                        </span>
                                    </span>
                                </label>
                            </div>
                            <h5 class="fs-13 text-center mt-2">{{ 'THEME_SETTINGS.LIGHT' | translate }}</h5>
                        </div>
                        <div class="col-4">
                            <div class="form-check card-radio">
                                <input class="form-check-input" type="radio" name="data-topbar" id="topbar-color-dark"
                                    value="dark" [checked]="topbar === 'dark'" (change)="changeTopColor('dark')">
                                <label class="form-check-label p-0 avatar-md w-100" for="topbar-color-dark">
                                    <span class="d-flex gap-1 h-100">
                                        <span class="flex-shrink-0">
                                            <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                                                <span
                                                    class="d-block p-1 px-2 bg-primary-subtle text-primary  rounded mb-2"></span>
                                                <span
                                                    class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                <span
                                                    class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                <span
                                                    class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                            </span>
                                        </span>
                                        <span class="flex-grow-1">
                                            <span class="d-flex h-100 flex-column">
                                                <span class="bg-primary d-block p-1"></span>
                                                <span class="bg-light d-block p-1 mt-auto"></span>
                                            </span>
                                        </span>
                                    </span>
                                </label>
                            </div>
                            <h5 class="fs-13 text-center mt-2">{{ 'THEME_SETTINGS.DARK' | translate }}</h5>
                        </div>
                    </div>
                    @if(layout === 'vertical'){
                      <div id="sidebar-size">
                        <h6 class="mt-4 mb-0 fw-semibold text-uppercase">{{ 'THEME_SETTINGS.SIDEBAR_SIZE' | translate }}</h6>
                        <p class="text-muted">{{ 'THEME_SETTINGS.CHOOSE_A_SIZE_OF_SIDEBAR' | translate }}</p>

                          <div class="row">
                              <div class="col-4">
                                  <div class="form-check sidebar-setting card-radio">
                                      <input class="form-check-input" type="radio" name="data-sidebar-size"
                                          id="sidebar-size-default" value="lg" [checked]="size === 'lg'"
                                          (change)="changeSidebarSize('lg')">
                                      <label class="form-check-label p-0 avatar-md w-100" for="sidebar-size-default">
                                          <span class="d-flex gap-1 h-100">
                                              <span class="flex-shrink-0">
                                                  <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                                                      <span
                                                          class="d-block p-1 px-2 bg-primary-subtle text-primary  rounded mb-2"></span>
                                                      <span
                                                          class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                      <span
                                                          class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                      <span
                                                          class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                  </span>
                                              </span>
                                              <span class="flex-grow-1">
                                                  <span class="d-flex h-100 flex-column">
                                                      <span class="bg-light d-block p-1"></span>
                                                      <span class="bg-light d-block p-1 mt-auto"></span>
                                                  </span>
                                              </span>
                                          </span>
                                      </label>
                                  </div>
                                <h5 class="fs-13 text-center mt-2">{{ 'THEME_SETTINGS.DEFAULT' | translate }}</h5>
                              </div>

                              <div class="col-4">
                                  <div class="form-check sidebar-setting card-radio">
                                      <input class="form-check-input" type="radio" name="data-sidebar-size"
                                          id="sidebar-size-compact" value="md" [checked]="size === 'md'"
                                          (change)="changeSidebarSize('md')">
                                      <label class="form-check-label p-0 avatar-md w-100" for="sidebar-size-compact">
                                          <span class="d-flex gap-1 h-100">
                                              <span class="flex-shrink-0">
                                                  <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                                                      <span
                                                          class="d-block p-1 bg-primary-subtle text-primary  rounded mb-2"></span>
                                                      <span
                                                          class="d-block p-1 pb-0 bg-primary-subtle text-primary "></span>
                                                      <span
                                                          class="d-block p-1 pb-0 bg-primary-subtle text-primary "></span>
                                                      <span
                                                          class="d-block p-1 pb-0 bg-primary-subtle text-primary "></span>
                                                  </span>
                                              </span>
                                              <span class="flex-grow-1">
                                                  <span class="d-flex h-100 flex-column">
                                                      <span class="bg-light d-block p-1"></span>
                                                      <span class="bg-light d-block p-1 mt-auto"></span>
                                                  </span>
                                              </span>
                                          </span>
                                      </label>
                                  </div>
                                <h5 class="fs-13 text-center mt-2">{{ 'THEME_SETTINGS.COMPACT' | translate }}</h5>
                              </div>

                              <div class="col-4">
                                  <div class="form-check sidebar-setting card-radio">
                                      <input class="form-check-input" type="radio" name="data-sidebar-size"
                                          id="sidebar-size-small" value="sm" [checked]="size === 'sm'"
                                          (change)="changeSidebarSize('sm')">
                                      <label class="form-check-label p-0 avatar-md w-100" for="sidebar-size-small">
                                          <span class="d-flex gap-1 h-100">
                                              <span class="flex-shrink-0">
                                                  <span class="bg-light d-flex h-100 flex-column gap-1">
                                                      <span
                                                          class="d-block p-1 bg-primary-subtle text-primary  mb-2"></span>
                                                      <span
                                                          class="d-block p-1 pb-0 bg-primary-subtle text-primary "></span>
                                                      <span
                                                          class="d-block p-1 pb-0 bg-primary-subtle text-primary "></span>
                                                      <span
                                                          class="d-block p-1 pb-0 bg-primary-subtle text-primary "></span>
                                                  </span>
                                              </span>
                                              <span class="flex-grow-1">
                                                  <span class="d-flex h-100 flex-column">
                                                      <span class="bg-light d-block p-1"></span>
                                                      <span class="bg-light d-block p-1 mt-auto"></span>
                                                  </span>
                                              </span>
                                          </span>
                                      </label>
                                  </div>
                                <h5 class="fs-13 text-center mt-2">{{ 'THEME_SETTINGS.SMALL_ICON_VIEW' | translate }}</h5>
                              </div>

                              <div class="col-4">
                                  <div class="form-check sidebar-setting card-radio">
                                      <input class="form-check-input" type="radio" name="data-sidebar-size"
                                          id="sidebar-size-small-hover" value="sm-hover" [checked]="size === 'sm-hover'"
                                          (change)="changeSidebarSize('sm-hover')">
                                      <label class="form-check-label p-0 avatar-md w-100" for="sidebar-size-small-hover">
                                          <span class="d-flex gap-1 h-100">
                                              <span class="flex-shrink-0">
                                                  <span class="bg-light d-flex h-100 flex-column gap-1">
                                                      <span
                                                          class="d-block p-1 bg-primary-subtle text-primary  mb-2"></span>
                                                      <span
                                                          class="d-block p-1 pb-0 bg-primary-subtle text-primary "></span>
                                                      <span
                                                          class="d-block p-1 pb-0 bg-primary-subtle text-primary "></span>
                                                      <span
                                                          class="d-block p-1 pb-0 bg-primary-subtle text-primary "></span>
                                                  </span>
                                              </span>
                                              <span class="flex-grow-1">
                                                  <span class="d-flex h-100 flex-column">
                                                      <span class="bg-light d-block p-1"></span>
                                                      <span class="bg-light d-block p-1 mt-auto"></span>
                                                  </span>
                                              </span>
                                          </span>
                                      </label>
                                  </div>
                                <h5 class="fs-13 text-center mt-2">{{ 'THEME_SETTINGS.SMALL_HOVER_VIEW' | translate }}</h5>
                              </div>
                          </div>
                      </div>
                      <div id="sidebar-view">
                        <h6 class="mt-4 mb-0 fw-semibold text-uppercase">{{ 'THEME_SETTINGS.SIDEBAR_VIEW' | translate }}</h6>
                        <p class="text-muted">{{ 'THEME_SETTINGS.SIDEBAR_VIEW_DESCRIPTION' | translate }}</p>

                          <div class="row">
                              <div class="col-4">
                                  <div class="form-check sidebar-setting card-radio">
                                      <input class="form-check-input" type="radio" name="data-layout-style"
                                          id="sidebar-view-default" value="default" [checked]="sidebarView === 'default'"
                                          (change)="changeSidebar('default')">
                                      <label class="form-check-label p-0 avatar-md w-100" for="sidebar-view-default">
                                          <span class="d-flex gap-1 h-100">
                                              <span class="flex-shrink-0">
                                                  <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                                                      <span
                                                          class="d-block p-1 px-2 bg-primary-subtle text-primary  rounded mb-2"></span>
                                                      <span
                                                          class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                      <span
                                                          class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                      <span
                                                          class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                  </span>
                                              </span>
                                              <span class="flex-grow-1">
                                                  <span class="d-flex h-100 flex-column">
                                                      <span class="bg-light d-block p-1"></span>
                                                      <span class="bg-light d-block p-1 mt-auto"></span>
                                                  </span>
                                              </span>
                                          </span>
                                      </label>
                                  </div>
                                  <h5 class="fs-13 text-center mt-2">{{ 'THEME_SETTINGS.DEFAULT'| translate }}</h5>
                              </div>
                              <div class="col-4">
                                  <div class="form-check sidebar-setting card-radio">
                                      <input class="form-check-input" type="radio" name="data-layout-style"
                                          id="sidebar-view-detached" value="detached"
                                          [checked]="sidebarView === 'detached'" (change)="changeSidebar('detached')">
                                      <label class="form-check-label p-0 avatar-md w-100" for="sidebar-view-detached">
                                          <span class="d-flex h-100 flex-column">
                                              <span class="bg-light d-flex p-1 gap-1 align-items-center px-2">
                                                  <span
                                                      class="d-block p-1 bg-primary-subtle text-primary  rounded me-1"></span>
                                                  <span
                                                      class="d-block p-1 pb-0 px-2 bg-primary-subtle text-primary  ms-auto"></span>
                                                  <span
                                                      class="d-block p-1 pb-0 px-2 bg-primary-subtle text-primary "></span>
                                              </span>
                                              <span class="d-flex gap-1 h-100 p-1 px-2">
                                                  <span class="flex-shrink-0">
                                                      <span class="bg-light d-flex h-100 flex-column gap-1 p-1">
                                                          <span
                                                              class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                          <span
                                                              class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                          <span
                                                              class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                      </span>
                                                  </span>
                                              </span>
                                              <span class="bg-light d-block p-1 mt-auto px-2"></span>
                                          </span>
                                      </label>
                                  </div>
                                  <h5 class="fs-13 text-center mt-2">{{ "THEME_SETTINGS.DETACHED" | translate }}</h5>
                              </div>
                          </div>
                      </div>
                      <div id="sidebar-color">
                        <h6 class="mt-4 mb-0 fw-semibold text-uppercase">{{ 'THEME_SETTINGS.SIDEBAR_COLOR' | translate }}</h6>
                        <p class="text-muted">{{ 'THEME_SETTINGS.SIDEBAR_COLOR_DESCRIPTION' | translate }}</p>

                        <div class="row">
                            <div class="col-4">
                                <div class="form-check sidebar-setting card-radio" data-bs-toggle="collapse"
                                    data-bs-target="#collapseBgGradient.show">
                                    <input class="form-check-input" type="radio" name="data-sidebar"
                                        id="sidebar-color-light" value="light" [checked]="sidebar === 'light'"
                                        (change)="changeSidebarColor('light')" (click)="removeActive()">
                                    <label class="form-check-label p-0 avatar-md w-100" for="sidebar-color-light">
                                        <span class="d-flex gap-1 h-100">
                                            <span class="flex-shrink-0">
                                                <span class="bg-white border-end d-flex h-100 flex-column gap-1 p-1">
                                                    <span
                                                        class="d-block p-1 px-2 bg-primary-subtle text-primary  rounded mb-2"></span>
                                                    <span
                                                        class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                    <span
                                                        class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                    <span
                                                        class="d-block p-1 px-2 pb-0 bg-primary-subtle text-primary "></span>
                                                </span>
                                            </span>
                                            <span class="flex-grow-1">
                                                <span class="d-flex h-100 flex-column">
                                                    <span class="bg-light d-block p-1"></span>
                                                    <span class="bg-light d-block p-1 mt-auto"></span>
                                                </span>
                                            </span>
                                        </span>
                                    </label>
                                </div>
                                <h5 class="fs-13 text-center mt-2">{{ "THEME_SETTINGS.LIGHT" | translate }}</h5>
                            </div>
                            <div class="col-4">
                                <div class="form-check sidebar-setting card-radio" data-bs-toggle="collapse"
                                    data-bs-target="#collapseBgGradient.show">
                                    <input class="form-check-input" type="radio" name="data-sidebar"
                                        id="sidebar-color-dark" value="dark" [checked]="sidebar === 'dark'"
                                        (change)="changeSidebarColor('dark')" (click)="removeActive()">
                                    <label class="form-check-label p-0 avatar-md w-100" for="sidebar-color-dark">
                                        <span class="d-flex gap-1 h-100">
                                            <span class="flex-shrink-0">
                                                <span class="bg-primary d-flex h-100 flex-column gap-1 p-1">
                                                    <span
                                                        class="d-block p-1 px-2 bg-light-subtle text-light  rounded mb-2"></span>
                                                    <span
                                                        class="d-block p-1 px-2 pb-0 bg-light-subtle text-light "></span>
                                                    <span
                                                        class="d-block p-1 px-2 pb-0 bg-light-subtle text-light "></span>
                                                    <span
                                                        class="d-block p-1 px-2 pb-0 bg-light-subtle text-light "></span>
                                                </span>
                                            </span>
                                            <span class="flex-grow-1">
                                                <span class="d-flex h-100 flex-column">
                                                    <span class="bg-light d-block p-1"></span>
                                                    <span class="bg-light d-block p-1 mt-auto"></span>
                                                </span>
                                            </span>
                                        </span>
                                    </label>
                                </div>
                                <h5 class="fs-13 text-center mt-2">{{ "THEME_SETTINGS.DARK" | translate }}</h5>
                            </div>

                        </div>
                        <!-- end row -->
                    </div>
                    }

                </div>
            </div>
        </ngx-simplebar>
    </div>
</div>
<ng-container *ngIf="showBackDrop">
    <div class="offcanvas-backdrop fade" id="backdrop" (click)="closeoffcanvas()"></div>
</ng-container>
